export default {"src":"/_next/static/media/clock_button.cfc90f3b.svg","height":74,"width":71};